import { ApiClientBase } from "api/ApiClientBase";
import qs from "qs";

class LoadingApiClient extends ApiClientBase {
    getSportObjectLoading(sportObjectId) {
        return this.get(`/api/v1/loading/sport-object/${sportObjectId}`).then((r) => r.data);
    }

    getMunicipalityLoading(municipalityId) {
        return this.get(`/api/v1/loading/municipality/${municipalityId}`).then((r) => r.data);
    }

    getRegionLoading(regionId) {
        return this.get(`/api/v1/loading/region/${regionId}`).then((r) => r.data);
    }

    getFederationLoading(federationId, payload) {
        return this.get(`/api/v1/loading/federation/${federationId}?${qs.stringify(payload)}`).then(
            (r) => r.data,
        );
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new LoadingApiClient();
